import type { ClinicalScopeT } from '@/entities/care-state-domain';

export function scopeToSelection(scope: ClinicalScopeT): string {
  switch (scope.type) {
    case 'patient':
      return 'patient:root';
    case 'problem':
      return `problem:${scope.id}`;
    case 'request':
      return `request:${scope.id}`;
    default: {
      const _exhaustive: never = scope;
      return _exhaustive;
    }
  }
}

export function selectionToScope(nodeId: string): ClinicalScopeT | null {
  if (nodeId === 'patient:root') return { type: 'patient' };
  if (nodeId.startsWith('problem:')) {
    return { type: 'problem', id: nodeId.slice('problem:'.length) };
  }
  if (nodeId.startsWith('request:')) {
    return { type: 'request', id: nodeId.slice('request:'.length) };
  }
  return null;
}

export function parseProblemIdFromRequestsFolderId(nodeId: string): string | null {
  // folder:problem:<problemId>:requests
  const prefix = 'folder:problem:';
  const suffix = ':requests';
  if (!nodeId.startsWith(prefix) || !nodeId.endsWith(suffix)) return null;
  const middle = nodeId.slice(prefix.length, -suffix.length);
  return middle.length > 0 ? middle : null;
}
